<div class="sub-page" *ngIf="merchantId && (userType === 100 || userType === 300 || userType === 301); else notAllowed">

  <!-- ── Header ───────────────────────────────────────────────────────── -->
  <div class="sub-header">
    <button class="btn-back" type="button" (click)="router.navigate(['/dashboard/dashboard'])">
      <i class="fa fa-arrow-left"></i>
    </button>
    <div>
      <h2 class="sub-title">{{ 'MerchantSubscriptions.title' | translate }}</h2>
      <p class="sub-subtitle">{{ 'MerchantSubscriptions.subtitle' | translate }}</p>
    </div>
    <div class="sub-header__actions">
      <button type="button" class="btn-merchant-payment" (click)="goMerchantPayment()">
        <i class="fa fa-credit-card"></i>
        <span>{{ 'MerchantSubscriptions.goToMerchantPayment' | translate }}</span>
      </button>
      <button class="btn-refresh" type="button" (click)="refreshAll()">
        <i class="fa fa-refresh"></i>
      </button>
    </div>
  </div>

  <!-- ── Tabs ─────────────────────────────────────────────────────────── -->
  <div class="sub-tabs">
    <button [class.active]="activeTab === 'overview'" (click)="activeTab = 'overview'">
      <i class="fa fa-tachometer me-1"></i>{{ 'MerchantSubscriptions.tabOverview' | translate }}
    </button>
    <button [class.active]="activeTab === 'plans'" (click)="activeTab = 'plans'">
      <i class="fa fa-list-alt me-1"></i>{{ 'MerchantSubscriptions.tabPlans' | translate }}
    </button>
    <button [class.active]="activeTab === 'history'" (click)="activeTab = 'history'">
      <i class="fa fa-history me-1"></i>{{ 'MerchantSubscriptions.tabHistory' | translate }}
    </button>
    <button [class.active]="activeTab === 'transactions'" (click)="activeTab = 'transactions'">
      <i class="fa fa-exchange me-1"></i>{{ 'MerchantSubscriptions.tabTransactions' | translate }}
    </button>
    <button [class.active]="activeTab === 'orders'" (click)="activeTab = 'orders'">
      <i class="fa fa-credit-card me-1"></i>{{ 'MerchantSubscriptions.tabOrders' | translate }}
    </button>
  </div>

  <!-- ════════════════════════════════════════════════════════════════════ -->
  <!--  TAB 1 — OVERVIEW                                                   -->
  <!-- ════════════════════════════════════════════════════════════════════ -->
  <div *ngIf="activeTab === 'overview'" class="tab-content">

    <div *ngIf="loadingStatus" class="loading-row">
      <span class="spinner-border spinner-border-sm"></span>
    </div>

    <div *ngIf="!loadingStatus && status" class="overview-layout">

      <div *ngIf="pendingPayableOrdersCount() > 0" class="overview-pending-alert" role="status">
        <div class="overview-pending-alert__icon"><i class="fa fa-credit-card"></i></div>
        <div class="overview-pending-alert__body">
          <strong>{{ 'MerchantSubscriptions.overviewPendingBanner' | translate: { count: pendingPayableOrdersCount() } }}</strong>
          <span class="overview-pending-alert__hint">{{ 'MerchantSubscriptions.paymentRedirect' | translate }}</span>
        </div>
        <button type="button" class="btn-primary-sm overview-pending-alert__btn" (click)="activeTab = 'orders'">
          {{ 'MerchantSubscriptions.overviewCompletePayment' | translate }}
        </button>
      </div>

      <ng-container *ngIf="status.subscription; else noSubHero">
        <section class="overview-card overview-card--hero" aria-labelledby="overview-sub-heading">
          <div class="overview-hero__top">
            <div class="overview-hero__intro">
              <div class="ov-label" id="overview-sub-heading">{{ 'MerchantSubscriptions.currentSubscription' | translate }}</div>
              <h3 class="overview-hero__plan-name">{{ currentPlanName() || ('MerchantSubscriptions.unknownPlan' | translate) }}</h3>
              <div class="overview-hero__dates">
                <span class="overview-date-chip">
                  <i class="fa fa-calendar-o" aria-hidden="true"></i>
                  {{ 'MerchantSubscriptions.overviewStarts' | translate }} {{ formatDate(status.subscription.start_date) }}
                </span>
                <span class="overview-date-chip">
                  <i class="fa fa-calendar-check-o" aria-hidden="true"></i>
                  {{ 'MerchantSubscriptions.overviewEnds' | translate }} {{ formatDate(status.subscription.end_date) }}
                </span>
              </div>
            </div>
            <div class="overview-hero__aside">
              <div class="overview-days-pill">
                <span class="overview-days-pill__num">{{ status.days_remaining }}</span>
                <span class="overview-days-pill__lbl">{{ 'MerchantSubscriptions.daysRemaining' | translate }}</span>
              </div>
              <span
                class="overview-status-badge"
                [class.overview-status-badge--on]="status.is_active"
                [class.overview-status-badge--off]="!status.is_active"
              >
                {{ status.is_active ? ('MerchantSubscriptions.active' | translate) : ('MerchantSubscriptions.inactive' | translate) }}
              </span>
            </div>
          </div>

          <ng-container *ngIf="subscriptionPeriodElapsedPercent() !== null">
            <button
              type="button"
              class="overview-collapse-toggle"
              (click)="toggleOverviewSection('period')"
              [attr.aria-expanded]="overviewSectionsOpen.period"
              aria-controls="overview-collapse-period"
              id="overview-toggle-period"
            >
              <span class="overview-collapse-toggle__label">{{ 'MerchantSubscriptions.overviewCollapsePeriod' | translate }}</span>
              <i
                class="fa fa-chevron-down overview-collapse-toggle__chev"
                [class.overview-collapse-toggle__chev--open]="overviewSectionsOpen.period"
                aria-hidden="true"
              ></i>
            </button>
            <div
              class="overview-collapse-panel"
              id="overview-collapse-period"
              role="region"
              [attr.aria-labelledby]="'overview-toggle-period'"
              [hidden]="!overviewSectionsOpen.period"
            >
              <div class="overview-timeline overview-timeline--in-panel">
                <div class="overview-section-kicker">{{ 'MerchantSubscriptions.overviewPeriodTimeline' | translate }}</div>
                <div class="overview-bar-head">
                  <span>{{ 'MerchantSubscriptions.overviewPeriodElapsed' | translate }}</span>
                  <span class="overview-bar-head__pct">{{ clampPct(subscriptionPeriodElapsedPercent()) }}%</span>
                </div>
                <div class="overview-bar overview-bar--lg">
                  <div class="overview-bar__fill overview-bar__fill--timeline" [style.width.%]="clampPct(subscriptionPeriodElapsedPercent())"></div>
                </div>
              </div>
            </div>
          </ng-container>

          <button
            type="button"
            class="overview-collapse-toggle"
            [class.overview-collapse-toggle--spaced]="subscriptionPeriodElapsedPercent() !== null"
            (click)="toggleOverviewSection('quotas')"
            [attr.aria-expanded]="overviewSectionsOpen.quotas"
            aria-controls="overview-collapse-quotas"
            id="overview-toggle-quotas"
          >
            <span class="overview-collapse-toggle__label">{{ 'MerchantSubscriptions.overviewCollapseQuotas' | translate }}</span>
            <i
              class="fa fa-chevron-down overview-collapse-toggle__chev"
              [class.overview-collapse-toggle__chev--open]="overviewSectionsOpen.quotas"
              aria-hidden="true"
            ></i>
          </button>
          <div
            class="overview-collapse-panel"
            id="overview-collapse-quotas"
            role="region"
            [attr.aria-labelledby]="'overview-toggle-quotas'"
            [hidden]="!overviewSectionsOpen.quotas"
          >
            <h4 class="overview-section-kicker overview-section-kicker--in-panel">{{ 'MerchantSubscriptions.overviewQuotaSection' | translate }}</h4>

            <div class="overview-quotas">
            <!-- Documents -->
            <div class="overview-quota-block">
              <div class="overview-quota-block__title">
                <span class="overview-quota-block__icon overview-quota-block__icon--doc"><i class="fa fa-file-text-o"></i></span>
                {{ 'MerchantSubscriptions.documents' | translate }}
              </div>
              <div class="overview-mini-stats">
                <div class="overview-mini-stat">
                  <span class="overview-mini-stat__val">{{ status.subscription.documents_used }}</span>
                  <span class="overview-mini-stat__lbl">{{ 'MerchantSubscriptions.overviewStatUsedInPeriod' | translate }}</span>
                </div>
                <div class="overview-mini-stat">
                  <span class="overview-mini-stat__val overview-mini-stat__val--ok">{{ status.documents_remaining }}</span>
                  <span class="overview-mini-stat__lbl">{{ 'MerchantSubscriptions.overviewStatRemaining' | translate }}</span>
                </div>
                <div class="overview-mini-stat">
                  <span class="overview-mini-stat__val">{{ status.subscription.documents_limit }}</span>
                  <span class="overview-mini-stat__lbl">{{ 'MerchantSubscriptions.overviewStatLimit' | translate }}</span>
                </div>
              </div>
              <div class="overview-bar-head">
                <span>{{ 'MerchantSubscriptions.overviewUsedShare' | translate }}</span>
                <span class="overview-bar-head__pct">{{ clampPct(overviewDocumentsUsedPct()) }}%</span>
              </div>
              <div class="overview-bar overview-bar--lg">
                <div
                  class="overview-bar__fill overview-bar__fill--doc"
                  [style.width.%]="clampPct(overviewDocumentsUsedPct())"
                  [class.overview-bar__fill--warn]="overviewDocumentsUsedPct() >= 75"
                  [class.overview-bar__fill--danger]="overviewDocumentsUsedPct() >= 95"
                ></div>
              </div>
              <p class="overview-quota-caption">
                <span>{{ status.subscription.documents_used }} / {{ status.subscription.documents_limit }}</span>
                <span class="sep" aria-hidden="true">·</span>
                <span>{{ status.documents_remaining }} {{ 'MerchantSubscriptions.overviewStatRemaining' | translate }}</span>
              </p>
              <p class="overview-quota-note">
                {{ 'MerchantSubscriptions.overviewDocumentsQuotaNote' | translate: {
                  start: formatDate(status.subscription.start_date),
                  end: formatDate(status.subscription.end_date)
                } }}
              </p>
            </div>

            <!-- Companies -->
            <div class="overview-quota-block">
              <div class="overview-quota-block__title">
                <span class="overview-quota-block__icon overview-quota-block__icon--co"><i class="fa fa-building"></i></span>
                {{ 'MerchantSubscriptions.companies' | translate }}
              </div>
              <div class="overview-mini-stats">
                <div class="overview-mini-stat">
                  <span class="overview-mini-stat__val">{{ status.subscription.companies_used }}</span>
                  <span class="overview-mini-stat__lbl">{{ 'MerchantSubscriptions.overviewStatUsed' | translate }}</span>
                </div>
                <div class="overview-mini-stat">
                  <span class="overview-mini-stat__val overview-mini-stat__val--ok">{{ status.companies_remaining }}</span>
                  <span class="overview-mini-stat__lbl">{{ 'MerchantSubscriptions.overviewStatRemaining' | translate }}</span>
                </div>
                <div class="overview-mini-stat">
                  <span class="overview-mini-stat__val">{{ status.subscription.companies_limit }}</span>
                  <span class="overview-mini-stat__lbl">{{ 'MerchantSubscriptions.overviewStatLimit' | translate }}</span>
                </div>
              </div>
              <div class="overview-bar-head">
                <span>{{ 'MerchantSubscriptions.overviewUsedShare' | translate }}</span>
                <span class="overview-bar-head__pct">{{ clampPct(overviewCompaniesUsedPct()) }}%</span>
              </div>
              <div class="overview-bar overview-bar--lg">
                <div
                  class="overview-bar__fill overview-bar__fill--co"
                  [style.width.%]="clampPct(overviewCompaniesUsedPct())"
                  [class.overview-bar__fill--warn]="overviewCompaniesUsedPct() >= 75"
                  [class.overview-bar__fill--danger]="overviewCompaniesUsedPct() >= 95"
                ></div>
              </div>
              <p class="overview-quota-caption">
                <span>{{ status.subscription.companies_used }} / {{ status.subscription.companies_limit }}</span>
                <span class="sep" aria-hidden="true">·</span>
                <span>{{ status.companies_remaining }} {{ 'MerchantSubscriptions.overviewStatRemaining' | translate }}</span>
              </p>
            </div>

            <!-- Analysis tokens -->
            <div class="overview-quota-block" *ngIf="showAnalysisTokenUsage()">
              <div class="overview-quota-block__title">
                <span class="overview-quota-block__icon overview-quota-block__icon--tok"><i class="fa fa-magic"></i></span>
                {{ 'MerchantSubscriptions.analysisTokens' | translate }}
              </div>
              <div class="overview-mini-stats">
                <div class="overview-mini-stat">
                  <span class="overview-mini-stat__val">{{ analysisTokensUsed() }}</span>
                  <span class="overview-mini-stat__lbl">{{ 'MerchantSubscriptions.overviewStatUsed' | translate }}</span>
                </div>
                <div class="overview-mini-stat">
                  <span class="overview-mini-stat__val overview-mini-stat__val--ok">{{ analysisTokensRemaining() }}</span>
                  <span class="overview-mini-stat__lbl">{{ 'MerchantSubscriptions.overviewStatRemaining' | translate }}</span>
                </div>
                <div class="overview-mini-stat">
                  <span class="overview-mini-stat__val">{{ analysisTokensLimit() }}</span>
                  <span class="overview-mini-stat__lbl">{{ 'MerchantSubscriptions.overviewStatLimit' | translate }}</span>
                </div>
              </div>
              <div class="overview-bar-head">
                <span>{{ 'MerchantSubscriptions.overviewUsedShare' | translate }}</span>
                <span
                  class="overview-bar-head__pct"
                  [class.text-warning]="analysisTokensUsagePercent() >= 70 && analysisTokensUsagePercent() < 90"
                  [class.text-danger]="analysisTokensUsagePercent() >= 90"
                >{{ analysisTokensUsagePercent() }}%</span>
              </div>
              <div class="overview-bar overview-bar--lg">
                <div
                  class="overview-bar__fill overview-bar__fill--tok"
                  [style.width.%]="analysisTokensUsagePercent()"
                  [class.overview-bar__fill--warn]="analysisTokensUsagePercent() >= 75"
                  [class.overview-bar__fill--danger]="analysisTokensUsagePercent() >= 95"
                ></div>
              </div>
              <p class="overview-quota-caption">
                <span>{{ analysisTokensUsed() }} / {{ analysisTokensLimit() }}</span>
                <span class="sep" aria-hidden="true">·</span>
                <span>{{ analysisTokensRemaining() }} {{ 'MerchantSubscriptions.overviewStatRemaining' | translate }}</span>
              </p>
            </div>
            </div>

            <div class="overview-chip-row">
              <span class="overview-chip"><i class="fa fa-file-o" aria-hidden="true"></i> {{ status.documents_remaining }} {{ 'MerchantSubscriptions.documentsRemaining' | translate }}</span>
              <span class="overview-chip"><i class="fa fa-building-o" aria-hidden="true"></i> {{ 'MerchantSubscriptions.overviewCompaniesRemaining' | translate: { n: status.companies_remaining } }}</span>
              <span class="overview-chip" *ngIf="showAnalysisTokenUsage()"><i class="fa fa-magic" aria-hidden="true"></i> {{ 'MerchantSubscriptions.tokensRemainingMeta' | translate: { n: analysisTokensRemaining() } }}</span>
            </div>
          </div>
        </section>
      </ng-container>

      <ng-template #noSubHero>
        <div class="overview-card overview-card--empty">
          <div class="renew-inactive">
            <i class="fa fa-exclamation-circle renew-icon-off"></i>
            <span>{{ 'MerchantSubscriptions.noActiveSubscription' | translate }}</span>
          </div>
          <button class="btn-primary-sm mt-3" type="button" (click)="activeTab = 'plans'">
            <i class="fa fa-plus me-1"></i>{{ 'MerchantSubscriptions.choosePlan' | translate }}
          </button>
        </div>
      </ng-template>

      <button
        type="button"
        class="overview-collapse-toggle overview-collapse-toggle--footer"
        *ngIf="status"
        (click)="toggleOverviewSection('footer')"
        [attr.aria-expanded]="overviewSectionsOpen.footer"
        aria-controls="overview-collapse-footer"
        id="overview-toggle-footer"
      >
        <span class="overview-collapse-toggle__label">{{ 'MerchantSubscriptions.overviewCollapseFooter' | translate }}</span>
        <i
          class="fa fa-chevron-down overview-collapse-toggle__chev"
          [class.overview-collapse-toggle__chev--open]="overviewSectionsOpen.footer"
          aria-hidden="true"
        ></i>
      </button>
      <div
        class="overview-collapse-panel overview-collapse-panel--footer"
        id="overview-collapse-footer"
        role="region"
        [attr.aria-labelledby]="'overview-toggle-footer'"
        [hidden]="!overviewSectionsOpen.footer"
        *ngIf="status"
      >
      <div class="overview-secondary-grid">
        <div class="overview-card overview-card--renew"
             [class.renew-on]="autoRenew?.auto_renew"
             [class.renew-off]="!autoRenew?.auto_renew">
          <div class="ov-label">{{ 'MerchantSubscriptions.autoRenewTitle' | translate }}</div>

          <div *ngIf="autoRenew?.auto_renew; else autoOff" class="renew-active">
            <i class="fa fa-check-circle renew-icon-on"></i>
            <div>
              <div class="renew-plan-name">{{ 'MerchantSubscriptions.autoRenewOn' | translate }}</div>
            </div>
          </div>
          <ng-template #autoOff>
            <div class="renew-inactive">
              <i class="fa fa-times-circle renew-icon-off"></i>
              <span>{{ 'MerchantSubscriptions.autoRenewOff' | translate }}</span>
            </div>
          </ng-template>

          <div class="renew-actions">
            <button
              *ngIf="autoRenew?.auto_renew && autoRenew?.can_cancel"
              type="button"
              class="btn-danger-sm"
              (click)="cancelAutoRenew()"
            >
              <i class="fa fa-ban me-1"></i>{{ 'MerchantSubscriptions.cancelAutoRenew' | translate }}
            </button>
            <button
              *ngIf="!autoRenew?.auto_renew"
              type="button"
              class="btn-primary-sm"
              (click)="startAutoRenewSelection()"
            >
              <i class="fa fa-plus me-1"></i>{{ 'MerchantSubscriptions.setAutoRenewPlanButton' | translate }}
            </button>
          </div>
        </div>

        <div class="overview-card overview-card--stats">
          <div class="ov-label">{{ 'MerchantSubscriptions.overviewActivitySummary' | translate }}</div>
          <div class="stats-row stats-row--wrap">
            <div class="stat-item">
              <div class="stat-num">{{ orders.length }}</div>
              <div class="stat-lbl">{{ 'MerchantSubscriptions.totalOrders' | translate }}</div>
            </div>
            <div class="stat-item">
              <div class="stat-num text-success">{{ completedOrdersCount }}</div>
              <div class="stat-lbl">{{ 'MerchantSubscriptions.completedOrders' | translate }}</div>
            </div>
            <div class="stat-item">
              <div class="stat-num">{{ history.length }}</div>
              <div class="stat-lbl">{{ 'MerchantSubscriptions.tabHistory' | translate }}</div>
            </div>
            <div class="stat-item" *ngIf="pendingPayableOrdersCount() > 0">
              <div class="stat-num text-warning">{{ pendingPayableOrdersCount() }}</div>
              <div class="stat-lbl">{{ 'MerchantSubscriptions.overviewPendingShort' | translate }}</div>
            </div>
          </div>
          <div class="overview-stats-links">
            <button class="btn-link-sm" type="button" (click)="activeTab = 'orders'">
              {{ 'MerchantSubscriptions.goToOrders' | translate }} →
            </button>
            <button class="btn-link-sm" type="button" (click)="activeTab = 'history'">
              {{ 'MerchantSubscriptions.overviewGoToHistory' | translate }} →
            </button>
            <button class="btn-link-sm" type="button" (click)="activeTab = 'plans'">
              {{ 'MerchantSubscriptions.goToPlans' | translate }} →
            </button>
          </div>
        </div>
      </div>
      </div>

    </div>

    <div *ngIf="!loadingStatus && !status" class="empty-state">
      <i class="fa fa-info-circle fa-2x mb-2 text-muted"></i>
      <p>{{ 'MerchantSubscriptions.noActiveSubscription' | translate }}</p>
    </div>
  </div>

  <!-- ════════════════════════════════════════════════════════════════════ -->
  <!--  TAB 2 — PLANS                                                      -->
  <!-- ════════════════════════════════════════════════════════════════════ -->
  <div *ngIf="activeTab === 'plans'" class="tab-content plans-tab">

    <div *ngIf="loadingPlans" class="loading-row">
      <span class="spinner-border spinner-border-sm"></span>
    </div>

    <div *ngIf="!loadingPlans" class="plans-tab-inner">

      <!-- Main subscription plans -->
      <section class="plans-section plans-section--primary">
        <header class="plans-section__head">
          <h3 class="plans-section__title">{{ 'MerchantSubscriptions.mainPlans' | translate }}</h3>
          <p class="plans-section__lead">{{ 'MerchantSubscriptions.plansTabLead' | translate }}</p>
        </header>
        <div class="plans-grid plans-grid--main">
          <article class="plan-card plan-card--tier"
                   *ngFor="let p of plans"
                   [class.plan-card--active]="selectedPlanId === p.id && selectedPlanType === 'subscription'"
                   [class.plan-card--current]="planRelation(p) === 'current'"
                   [class.plan-card--upgrade]="planRelation(p) === 'upgrade'">

            <div *ngIf="planRelation(p) === 'current'" class="plan-relation-badge plan-relation-badge--current">
              <i class="fa fa-check-circle me-1"></i>
              {{ 'MerchantSubscriptions.currentPlanBadge' | translate }}
            </div>
            <div *ngIf="planRelation(p) === 'upgrade'" class="plan-relation-badge plan-relation-badge--upgrade"
                 [class.plan-relation-badge--next]="isNextUpgradePlan(p)">
              <i class="fa fa-arrow-up me-1"></i>
              {{ (isNextUpgradePlan(p) ? 'MerchantSubscriptions.upgradeNextBadge' : 'MerchantSubscriptions.upgradePlan') | translate }}
            </div>

            <div class="plan-name">{{ planName(p) }}</div>

            <div class="plan-spec-grid">
              <div class="plan-spec">
                <span class="plan-spec__icon" aria-hidden="true"><i class="fa fa-file-text-o"></i></span>
                <span class="plan-spec__value">{{ p.documents_limit }}</span>
                <span class="plan-spec__label">{{ 'MerchantSubscriptions.documents' | translate }}</span>
              </div>
              <div class="plan-spec">
                <span class="plan-spec__icon plan-spec__icon--violet" aria-hidden="true"><i class="fa fa-building"></i></span>
                <span class="plan-spec__value">{{ p.companies_limit }}</span>
                <span class="plan-spec__label">{{ 'MerchantSubscriptions.companies' | translate }}</span>
              </div>
              <div class="plan-spec plan-spec--tokens">
                <span class="plan-spec__icon plan-spec__icon--amber" aria-hidden="true"><i class="fa fa-magic"></i></span>
                <span class="plan-spec__value" *ngIf="p.analysis_tokens_limit != null">{{ p.analysis_tokens_limit }}</span>
                <span class="plan-spec__value plan-spec__value--muted" *ngIf="p.analysis_tokens_limit == null">—</span>
                <span class="plan-spec__label">{{ 'MerchantSubscriptions.analysisTokensShort' | translate }}</span>
              </div>
            </div>

            <p class="plan-desc plan-desc--clamp" *ngIf="planDescription(p)">{{ planDescription(p) }}</p>

            <div class="plan-footer">
              <div class="plan-price-block">
                <span class="plan-price">₪{{ p.price | number:'1.2-2' }}</span>
                <span class="plan-duration" *ngIf="p.duration_days">
                  / {{ 'MerchantSubscriptions.planDurationDays' | translate: { days: p.duration_days } }}
                </span>
              </div>
              <div class="plan-btns">
                <div *ngIf="planRelation(p) === 'current' && !autoRenewSelectionMode" class="plan-current-label">
                  <i class="fa fa-check me-1"></i>
                  {{ 'MerchantSubscriptions.currentPlanBadge' | translate }}
                </div>
                <button *ngIf="planRelation(p) === 'current' && autoRenewSelectionMode"
                        type="button" class="btn-buy" (click)="pickPlan(p.id, 'subscription')">
                  <i class="fa fa-repeat me-1"></i>
                  {{ 'MerchantSubscriptions.setAutoRenewPlanButton' | translate }}
                </button>
                <button *ngIf="planRelation(p) === 'upgrade' && !autoRenewSelectionMode"
                        type="button" class="btn-upgrade" [class.btn-upgrade--next]="isNextUpgradePlan(p)"
                        (click)="pickPlan(p.id, 'subscription')">
                  <i class="fa fa-arrow-up me-1"></i>
                  {{ (isNextUpgradePlan(p) ? 'MerchantSubscriptions.upgradePlanShort' : 'MerchantSubscriptions.upgradePlan') | translate }}
                </button>
                <button *ngIf="planRelation(p) === 'upgrade' && autoRenewSelectionMode"
                        type="button" class="btn-upgrade" [class.btn-upgrade--next]="isNextUpgradePlan(p)"
                        (click)="pickPlan(p.id, 'subscription')">
                  <i class="fa fa-repeat me-1"></i>
                  {{ 'MerchantSubscriptions.setAutoRenewPlanButton' | translate }}
                </button>
                <button *ngIf="planRelation(p) !== 'current' && planRelation(p) !== 'upgrade' && !autoRenewSelectionMode"
                        type="button" class="btn-buy" (click)="pickPlan(p.id, 'subscription')">
                  <i class="fa fa-credit-card me-1"></i>
                  {{ 'MerchantSubscriptions.choosePlan' | translate }}
                </button>
                <button *ngIf="autoRenewSelectionMode"
                        type="button" class="btn-buy" (click)="pickPlan(p.id, 'subscription')">
                  <i class="fa fa-repeat me-1"></i>
                  {{ 'MerchantSubscriptions.setAutoRenewPlanButton' | translate }}
                </button>
              </div>
            </div>
          </article>
        </div>
      </section>

      <!-- Document add-ons -->
      <section class="plans-section plans-section--addons">
        <header class="plans-section__head">
          <h3 class="plans-section__title plans-section__title--sm">{{ 'MerchantSubscriptions.docExtensions' | translate }}</h3>
        </header>
        <div class="plans-grid plans-grid--addons">
          <article class="addon-card"
                   *ngFor="let e of docExtensions"
                   [class.addon-card--active]="selectedPlanId === e.id && selectedPlanType === 'doc'">
            <div class="addon-card__icon addon-card__icon--doc"><i class="fa fa-file-text-o"></i></div>
            <div class="addon-card__body">
              <div class="addon-card__name">{{ addonDisplayName(e) }}</div>
              <div class="addon-card__metric">
                <span class="addon-card__metric-val">+{{ e.extra_documents }}</span>
                <span class="addon-card__metric-lbl">{{ 'MerchantSubscriptions.documents' | translate }}</span>
              </div>
              <div class="addon-card__price">₪{{ e.price | number:'1.2-2' }}</div>
            </div>
            <button type="button" class="btn-subscribe" (click)="pickPlan(e.id, 'doc')">
              {{ 'MerchantSubscriptions.buyExtension' | translate }}
            </button>
          </article>
        </div>
      </section>

      <!-- Company add-ons -->
      <section class="plans-section plans-section--addons">
        <header class="plans-section__head">
          <h3 class="plans-section__title plans-section__title--sm">{{ 'MerchantSubscriptions.companyExtensions' | translate }}</h3>
        </header>
        <div class="plans-grid plans-grid--addons">
          <article class="addon-card"
                   *ngFor="let e of companyExtensions"
                   [class.addon-card--active]="selectedPlanId === e.id && selectedPlanType === 'company'">
            <div class="addon-card__icon addon-card__icon--co"><i class="fa fa-building"></i></div>
            <div class="addon-card__body">
              <div class="addon-card__name">{{ addonDisplayName(e) }}</div>
              <div class="addon-card__metric">
                <span class="addon-card__metric-val">+{{ e.extra_companies }}</span>
                <span class="addon-card__metric-lbl">{{ 'MerchantSubscriptions.companies' | translate }}</span>
              </div>
              <div class="addon-card__price">₪{{ e.price | number:'1.2-2' }}</div>
            </div>
            <button type="button" class="btn-subscribe" (click)="pickPlan(e.id, 'company')">
              {{ 'MerchantSubscriptions.buyExtension' | translate }}
            </button>
          </article>
        </div>
      </section>

      <!-- Token extensions (AI analysis) -->
      <section class="plans-section plans-section--addons plans-section--tokens" *ngIf="tokenExtensions.length > 0">
        <header class="plans-section__head">
          <h3 class="plans-section__title plans-section__title--sm">{{ 'MerchantSubscriptions.tokenExtensions' | translate }}</h3>
          <p class="plans-section__lead plans-section__lead--sm">{{ 'MerchantSubscriptions.tokenExtensionsHint' | translate }}</p>
        </header>
        <div class="plans-grid plans-grid--addons">
          <article class="addon-card addon-card--token"
                   *ngFor="let e of tokenExtensions"
                   [class.addon-card--active]="selectedPlanId === e.id && selectedPlanType === 'token'">
            <div class="addon-card__icon addon-card__icon--tok"><i class="fa fa-magic"></i></div>
            <div class="addon-card__body">
              <div class="addon-card__name">{{ tokenExtensionLabel(e) }}</div>
              <div class="addon-card__metric" *ngIf="e.extra_tokens != null">
                <span class="addon-card__metric-val">+{{ e.extra_tokens }}</span>
                <span class="addon-card__metric-lbl">{{ 'MerchantSubscriptions.analysisTokensShort' | translate }}</span>
              </div>
              <div class="addon-card__price">₪{{ e.price | number:'1.2-2' }}</div>
            </div>
            <button type="button" class="btn-subscribe btn-subscribe--token" (click)="pickPlan(e.id, 'token')">
              {{ 'MerchantSubscriptions.buyExtension' | translate }}
            </button>
          </article>
        </div>
      </section>
    </div>
  </div>

  <!-- ════════════════════════════════════════════════════════════════════ -->
  <!--  TAB 3 — HISTORY                                                    -->
  <!-- ════════════════════════════════════════════════════════════════════ -->
  <div *ngIf="activeTab === 'history'" class="tab-content">
    <div *ngIf="loadingHistory" class="loading-row">
      <span class="spinner-border spinner-border-sm"></span>
    </div>
    <div *ngIf="!loadingHistory && history.length === 0" class="empty-state">
      <i class="fa fa-inbox fa-2x mb-2 text-muted"></i>
      <p>{{ 'MerchantSubscriptions.noHistory' | translate }}</p>
    </div>
    <div class="table-responsive" *ngIf="!loadingHistory && history.length > 0">
      <table class="orders-table">
        <thead>
          <tr>
            <th>#</th>
            <th>{{ 'MerchantSubscriptions.plan' | translate }}</th>
            <th>{{ 'MerchantSubscriptions.period' | translate }}</th>
            <th>{{ 'MerchantSubscriptions.documents' | translate }}</th>
            <th>{{ 'MerchantSubscriptions.companies' | translate }}</th>
            <th>{{ 'MerchantSubscriptions.status' | translate }}</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let h of history">
            <td class="text-muted small">#{{ h.id }}</td>
            <td class="fw-medium">
              {{ h.plan ? planName(h.plan) : ('MerchantSubscriptions.unknownPlan' | translate) }}
            </td>
            <td>{{ formatDate(h.start_date) }} → {{ formatDate(h.end_date) }}</td>
            <td>
              <ng-container *ngIf="h.documents_limit != null">
                {{ h.documents_used || 0 }} / {{ h.documents_limit }}
              </ng-container>
              <ng-container *ngIf="h.documents_limit == null">—</ng-container>
            </td>
            <td>
              <ng-container *ngIf="h.companies_limit != null">
                {{ h.companies_used || 0 }} / {{ h.companies_limit }}
              </ng-container>
              <ng-container *ngIf="h.companies_limit == null">—</ng-container>
            </td>
            <td>
              <span [ngClass]="orderStatusClasses(h.status)">{{ orderStatusLabel(h.status) }}</span>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>

  <!-- ════════════════════════════════════════════════════════════════════ -->
  <!--  TAB 4 — ORDERS                                                     -->
  <!-- ════════════════════════════════════════════════════════════════════ -->
  <div *ngIf="activeTab === 'transactions'" class="tab-content">
    <!-- Loading -->
    <div *ngIf="loadingTx" class="loading-row">
      <span class="spinner-border spinner-border-sm"></span>
    </div>

    <!-- Empty -->
    <div *ngIf="!loadingTx && !transactions.length" class="empty-state">
      <i class="fa fa-inbox fa-2x mb-2 text-muted"></i>
      <p>
        {{
          lang === 'en'
            ? 'No transactions yet.'
            : lang === 'ar'
              ? 'لا توجد معاملات بعد.'
              : 'אין עסקאות עדיין.'
        }}
      </p>
    </div>

    <!-- Table (same as merchant-payment) -->
    <div class="table-responsive" *ngIf="!loadingTx && transactions.length">
      <table class="table table-hover align-middle mb-0 transactions-table">
        <thead class="table-dark transactions-table__head">
          <tr>
            <th class="text-center">#</th>
            <th>{{ lang === 'en' ? 'Customer' : (lang === 'ar' ? 'الزبون' : 'לקוח') }}</th>
            <th>{{ lang === 'en' ? 'Description' : (lang === 'ar' ? 'الوصف' : 'תיאור') }}</th>
            <th>{{ lang === 'en' ? 'Amount' : (lang === 'ar' ? 'المبلغ' : 'סכום') }}</th>
            <th>{{ lang === 'en' ? 'Card' : (lang === 'ar' ? 'الكارت' : 'כרטיס') }}</th>
            <th>{{ lang === 'en' ? 'Invoice' : (lang === 'ar' ? 'الفاتورة' : 'חשבונית') }}</th>
            <th>{{ lang === 'en' ? 'Status' : (lang === 'ar' ? 'الحالة' : 'סטטוס') }}</th>
            <th>{{ lang === 'en' ? 'Date' : (lang === 'ar' ? 'التاريخ' : 'תאריך') }}</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let tx of transactions">
            <td class="text-center text-muted small">#{{ tx.id }}</td>
            <td>
              <div class="fw-medium">{{ tx.customerName || '—' }}</div>
              <div class="text-muted small" *ngIf="tx.customerEmail">{{ tx.customerEmail }}</div>
            </td>
            <td class="small">{{ tx.description || '—' }}</td>
            <td class="fw-semibold">
              {{ tx.amount }}
              <span class="text-muted small ms-1">{{ tx.currencyCode }}</span>
            </td>
            <td>
              <span class="fw-medium">••••&nbsp;{{ tx.cardLast4 }}</span>
              <div class="text-muted small">{{ tx.cardHolderName }}</div>
            </td>
            <td class="text-nowrap">
              <button
                *ngIf="tx.issuedInvoicePdfUrl || tx.issuedInvoiceId || tx.invoiceId || tx.invoice?.id || tx.issuedInvoice?.id"
                type="button"
                class="btn btn-sm btn-outline-dark"
                [disabled]="loadingInvoicePdf"
                (click)="showInvoice(tx)"
              >
                <i class="fa fa-file-pdf-o me-1"></i>
                {{ lang === 'en' ? 'View' : (lang === 'ar' ? 'عرض' : 'צפה') }}
              </button>
              <span *ngIf="!(tx.issuedInvoicePdfUrl || tx.issuedInvoiceId || tx.invoiceId || tx.invoice?.id || tx.issuedInvoice?.id)" class="text-muted">—</span>
            </td>
            <td>
              <span class="badge rounded-pill px-3 py-2 tx-status-badge {{ txStatusBadge(tx.status) }}">
                {{ tx.status }}
              </span>
            </td>
            <td class="small text-nowrap tx-date">{{ formatDateTime(tx.createdAt) }}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>

  <div *ngIf="activeTab === 'orders'" class="tab-content">
    <div *ngIf="loadingOrders" class="loading-row">
      <span class="spinner-border spinner-border-sm"></span>
    </div>
    <div *ngIf="!loadingOrders && orders.length === 0" class="empty-state">
      <i class="fa fa-inbox fa-2x mb-2 text-muted"></i>
      <p>{{ 'MerchantSubscriptions.noOrders' | translate }}</p>
    </div>
    <ng-container *ngIf="!loadingOrders && orders.length > 0">
      <p class="orders-tab-lead">{{ 'MerchantSubscriptions.ordersTabLead' | translate }}</p>
      <div class="table-responsive orders-table-wrap">
        <table class="orders-table orders-table--purchase">
          <thead>
            <tr>
              <th>#</th>
              <th>{{ 'MerchantSubscriptions.orderId' | translate }}</th>
              <th>{{ 'MerchantSubscriptions.type' | translate }}</th>
              <th>{{ 'MerchantSubscriptions.amount' | translate }}</th>
              <th>{{ 'MerchantSubscriptions.status' | translate }}</th>
              <th>{{ 'MerchantSubscriptions.date' | translate }}</th>
              <th>{{ 'MerchantSubscriptions.actions' | translate }}</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let o of orders; let i = index">
              <td class="orders-table__index">{{ i + 1 }}</td>
              <td class="orders-table__mono">{{ o.order_id }}</td>
              <td>
                <span [ngClass]="orderTypeClasses(o.type)">
                  <i
                    class="fa order-type-chip__icon"
                    [class.fa-repeat]="o.type !== 'subscription'"
                    [class.fa-credit-card]="o.type === 'subscription'"
                  ></i>
                  {{ orderTypeLabel(o.type) }}
                </span>
              </td>
              <td class="orders-table__amount">₪ {{ o.amount }}</td>
              <td class="orders-table__status-cell">
                <span [ngClass]="orderStatusClasses(o.status)">{{ orderStatusLabel(o.status) }}</span>
                <ng-container *ngIf="o.status === 'pending' && o.payment_url">
                  <div *ngIf="isOrderLinkExpired(o)" class="orders-payment-meta orders-payment-meta--danger">
                    <i class="fa fa-clock-o"></i>
                    {{ orderLinkExpiryLabel(o) }}
                  </div>
                  <div *ngIf="!isOrderLinkExpired(o) && o.link_expiry_datetime" class="orders-payment-meta">
                    <i class="fa fa-clock-o"></i>
                    {{ orderLinkExpiryLabel(o) }}
                  </div>
                </ng-container>
              </td>
              <td class="order-date-cell">{{ formatDate(o.created_at) }}</td>
              <td class="orders-table__actions-cell">
                <div class="orders-actions-stack">
                  <ng-container *ngIf="o.status === 'pending' && o.payment_url && !isOrderLinkExpired(o)">
                    <button type="button" class="orders-btn orders-btn--pay" (click)="openOrderPaymentLink(o)">
                      <i class="fa fa-external-link"></i>
                      {{ 'MerchantSubscriptions.openPaymentLink' | translate }}
                    </button>
                  </ng-container>
                  <button
                    *ngIf="canCancelOrder(o)"
                    type="button"
                    class="orders-btn orders-btn--cancel"
                    (click)="cancelPendingOrder(o)"
                    [disabled]="cancellingOrderId === o.id"
                  >
                    <span *ngIf="cancellingOrderId === o.id" class="spinner-border spinner-border-sm me-1"></span>
                    {{ 'MerchantSubscriptions.cancelPendingOrder' | translate }}
                  </button>
                  <span
                    *ngIf="
                      !canCancelOrder(o) &&
                      !(o.status === 'pending' && o.payment_url && !isOrderLinkExpired(o))
                    "
                    class="orders-actions-placeholder"
                  >—</span>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </ng-container>
  </div>

</div>

<div class="invoice-modal-overlay" *ngIf="showInvoicePanel" (click)="closeInvoicePanel()">
  <div class="invoice-modal-box" (click)="$event.stopPropagation()">
    <div class="invoice-modal-box__header">
      <h5 class="mb-0">
        <i class="fa fa-file-pdf-o me-2"></i>
        {{ lang === 'en' ? 'Invoice Preview' : (lang === 'ar' ? 'معاينة الفاتورة' : 'תצוגת חשבונית') }}
      </h5>
      <div class="invoice-modal-actions">
        <button type="button" class="invoice-open-tab-btn" (click)="openInvoiceInNewTab()">
          <i class="fa fa-external-link me-1"></i>
          {{ lang === 'en' ? 'Open in new tab' : (lang === 'ar' ? 'فتح في نافذة جديدة' : 'פתח בלשונית חדשה') }}
        </button>
        <button type="button" class="invoice-modal-close" (click)="closeInvoicePanel()" aria-label="Close">
          ×
        </button>
      </div>
    </div>
    <div class="invoice-modal-box__body">
      <iframe
        *ngIf="invoicePdfUrl"
        [src]="invoicePdfUrl"
        class="invoice-modal-iframe"
        frameborder="0"
      ></iframe>
    </div>
  </div>
</div>

<!-- ── Not allowed ────────────────────────────────────────────────────── -->
<ng-template #notAllowed>
  <div class="sub-page">
    <div class="empty-state">
      <i class="fa fa-lock fa-2x mb-2 text-muted"></i>
      <p>{{ 'MerchantSubscriptions.notAllowed' | translate }}</p>
    </div>
  </div>
</ng-template>

<!-- ══════════════════════════════════════════════════════════════════════ -->
<!--  Purchase Confirmation Modal                                          -->
<!-- ══════════════════════════════════════════════════════════════════════ -->
<div class="modal-overlay" *ngIf="selectedPlanId" (click)="selectedPlanId = null">
  <div class="modal-box" (click)="$event.stopPropagation()">
    <div class="modal-box-header">
      <h5>{{ 'MerchantSubscriptions.confirmPurchase' | translate }}</h5>
      <button class="btn-close-modal" type="button" (click)="selectedPlanId = null">×</button>
    </div>

    <div class="modal-box-body">
      <div class="modal-plan-summary">
        <div class="modal-plan-name">
          {{ 'MerchantSubscriptions.selectedPlanType.' + selectedPlanType | translate }}
        </div>
        <div class="modal-plan-docs">
          <span *ngIf="selectedPlanType === 'subscription' && plans">
            {{ planName(plans?.[selectedPlanIndex()] || plans?.[0]) }}
          </span>
          <span *ngIf="selectedPlanType === 'doc' && docExtensions?.[selectedExtIndex('doc')]">
            {{ addonDisplayName(docExtensions?.[selectedExtIndex('doc')]) }}
          </span>
          <span *ngIf="selectedPlanType === 'company' && companyExtensions?.[selectedExtIndex('company')]">
            {{ addonDisplayName(companyExtensions?.[selectedExtIndex('company')]) }}
          </span>
          <span *ngIf="selectedPlanType === 'token' && tokenExtensions?.[selectedExtIndex('token')]">
            {{ tokenExtensionLabel(tokenExtensions?.[selectedExtIndex('token')]) }}
          </span>
        </div>
        <div class="modal-plan-price">
          <ng-container *ngIf="selectedPlanType === 'subscription' && plans?.[selectedPlanIndex()]">
            ₪ {{ plans?.[selectedPlanIndex()]?.price }}
          </ng-container>
          <ng-container *ngIf="selectedPlanType === 'doc' && docExtensions?.[selectedExtIndex('doc')]">
            ₪ {{ docExtensions?.[selectedExtIndex('doc')]?.price }}
          </ng-container>
          <ng-container *ngIf="selectedPlanType === 'company' && companyExtensions?.[selectedExtIndex('company')]">
            ₪ {{ companyExtensions?.[selectedExtIndex('company')]?.price }}
          </ng-container>
          <ng-container *ngIf="selectedPlanType === 'token' && tokenExtensions?.[selectedExtIndex('token')]">
            ₪ {{ tokenExtensions?.[selectedExtIndex('token')]?.price }}
          </ng-container>
        </div>
      </div>

      <div *ngIf="loadingSavedCardStatus" class="modal-saved-card-status modal-saved-card-status--loading" role="status">
        <span class="spinner-border spinner-border-sm me-2" aria-hidden="true"></span>
        {{ 'MerchantSubscriptions.savedCardStatusChecking' | translate }}
      </div>
      <div *ngIf="!loadingSavedCardStatus && hasActiveSavedCard === true" class="modal-saved-card-status modal-saved-card-status--on">
        <i class="fa fa-check-circle" aria-hidden="true"></i>
        <span>{{ 'MerchantSubscriptions.savedCardStatusOnFile' | translate }}</span>
      </div>
      <div *ngIf="!loadingSavedCardStatus && hasActiveSavedCard === false" class="modal-saved-card-status modal-saved-card-status--off">
        <i class="fa fa-info-circle" aria-hidden="true"></i>
        <span>{{ 'MerchantSubscriptions.savedCardStatusNone' | translate }}</span>
      </div>

      <ng-container *ngIf="selectedPlanType === 'subscription'">
        <label class="modal-option" *ngIf="hasActiveSavedCard !== true">
          <input
            type="checkbox"
            [(ngModel)]="saveCardOnSubscriptionPurchase"
            [disabled]="autoRenewOnPurchase"
          />
          <span>
            <i class="fa fa-credit-card me-1"></i>
            {{ 'MerchantSubscriptions.saveCardOption' | translate }}
            <small *ngIf="autoRenewOnPurchase" class="modal-option-hint d-block">
              {{ 'MerchantSubscriptions.saveCardIncludedWithAutoRenew' | translate }}
            </small>
          </span>
        </label>
        <label class="modal-option">
          <input
            type="checkbox"
            [(ngModel)]="autoRenewOnPurchase"
            (ngModelChange)="onSubscriptionAutoRenewChange($event)"
          />
          <span>
            <i class="fa fa-repeat me-1"></i>
            {{ 'MerchantSubscriptions.autoRenewOption' | translate }}
            <small class="modal-option-hint d-block">
              <i class="fa fa-info-circle me-1" aria-hidden="true"></i>
              {{
                hasActiveSavedCard === true
                  ? ('MerchantSubscriptions.autoRenewHintSavedCard' | translate)
                  : ('MerchantSubscriptions.autoRenewHint' | translate)
              }}
            </small>
          </span>
        </label>
      </ng-container>

      <label
        class="modal-option"
        *ngIf="(selectedPlanType === 'doc' || selectedPlanType === 'company') && hasActiveSavedCard !== true"
      >
        <input type="checkbox" [(ngModel)]="saveCardOnAddonPurchase" />
        <span>
          <i class="fa fa-credit-card me-1"></i>
          {{ 'MerchantSubscriptions.saveCardOption' | translate }}
        </span>
      </label>
    </div>

    <div class="modal-box-footer">
      <button class="btn-outline-sm" type="button" (click)="selectedPlanId = null" [disabled]="purchasing">
        {{ 'MerchantSubscriptions.cancel' | translate }}
      </button>
      <button class="btn-confirm" type="button" (click)="confirmPurchase()" [disabled]="purchasing">
        <span *ngIf="purchasing" class="spinner-border spinner-border-sm me-1"></span>
        {{ 'MerchantSubscriptions.payNow' | translate }}
      </button>
    </div>
  </div>
</div>
